import { apiService } from '.'

export const contentService = {
  getContent,
  updateContent
}

function getContent() {
  return apiService.fetchAuthGet('content')
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}

function updateContent(updateContent){
  return apiService.fetchAuthPut('content',updateContent)
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(error => {
      return error
    })
}
